export default __webpack_public_path__ + "static/media/cc.4f622a67.png";